import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MenuItem, Select, Typography } from "@material-ui/core";

function TimePicker(props) {
  const [time, setTime] = useState(props.time);
  let [hourSplitted, minuteSplitted] = time.split(":");
  const [hour, setHour] = useState(hourSplitted);
  const [minute, setMinute] = useState(minuteSplitted);

  useEffect(() => {
    let time = hour + ":" + minute;
    setTime(time);
    props.onChange(time);
  }, [hour, minute]);

  return (
    <>
      <Select
        value={hour}
        onChange={(e) => {
          setHour(e.target.value);
        }}
      >
        {props.hours.map((hour) => (
          <MenuItem value={hour}>{hour}</MenuItem>
        ))}
      </Select>
      <Typography style={{ fontWeight: 800, margin: 6 }}>:</Typography>
      <Select
        value={minute}
        onChange={(e) => {
          setMinute(e.target.value);
        }}
      >
        {props.minutes.map((minute) => (
          <MenuItem value={minute}>{minute}</MenuItem>
        ))}
      </Select>
    </>
  );
}

TimePicker.propTypes = {
  time: PropTypes.string.isRequired,
  hours: PropTypes.array.isRequired,
  minutes: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TimePicker;
